export const delegatedPermissionPartials = {
  title: "Calendar Access Required",
  description:
    "We don't have permission to access your calendar. If you want to create a reservation from Tactic, you need to grant us permission.",
  buttonText: "Connect Outlook",
  organizerDescription:
    "This organizer hasn't given Tactic access to their Outlook calendar, so the reservation can't be saved for them. Ask them to connect Outlook in Tactic first.",
  requiredError:
    "This reservation syncs with Outlook, and its organizer hasn't given Tactic access to their calendar. Ask them to connect Outlook in Tactic and try again."
};
